import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProductIndicatorBadge from 'common/ProductIndicatorBadge';
import AuthorizationVolumes from './AuthorizationVolumes';

const ProductDetails = ({ product, info, setInfo }) => {
  const { productNameShort, productIdName, proprietary } = product;

  // productIndex :: Product -> Number
  const productIndex = R.not(R.isNil(info.products))
    ? R.findIndex(R.equals(product), info.products)
    : 0;

  return (
    <Accordion
      defaultExpanded
      sx={{ '&:before': { display: 'none' }, backgroundColor: 'transparent', boxShadow: 'none' }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 44, px: 0 }}>
        <Stack direction="row" spacing={1}>
          <Box
            alignItems="center"
            borderRadius="4px"
            display="flex"
            height={20}
            justifyContent="center"
            minWidth={44}
            p={0.5}
            sx={{ backgroundColor: 'graphic.light', color: 'text.secondary' }}
          >
            {productIdName}
          </Box>
          <Typography>{productNameShort}</Typography>
          <ProductIndicatorBadge proprietary={proprietary} />
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        <AuthorizationVolumes dataPath={['products', productIndex]} info={info} setInfo={setInfo} />
      </AccordionDetails>
    </Accordion>
  );
};

ProductDetails.propTypes = {
  info: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  product: PropTypes.shape({
    productIdName: PropTypes.string,
    productNameShort: PropTypes.string,
    proprietary: PropTypes.string,
  }).isRequired,
  setInfo: PropTypes.func.isRequired,
};

ProductDetails.defaultProps = {
  info: {},
};

export default ProductDetails;
